<template>
  <Row
    type="flex"
    justify="center"
    class="content-section border-top"
    :class="{
      'content-section-light': tone === 'light',
      'content-section-dark': tone === 'dark',
    }">
    <Col span="24">
      <Row type="flex" justify="center">
        <!-- Let's Get Started! -->
        <h1 class="content-text-title">
          <!-- Invest in Your Financial Data & Analytics -->
          <!-- Invest in Your Financial Reporting -->
          Invest in Your Financial Data
        </h1>
      </Row>
      <Row type="flex" justify="center">
        <h2 class="content-text-sub-title">
          <!-- Invest in your process. Get started now for free. -->
          <!-- Invest in your process! -->
          <!-- and start achieving more with your portfolio. Get Started for free, cancel any time. -->
          <strong>Start building</strong> the metrics and reports you need to <strong>achieve more with your portfolio</strong>.
        </h2>
      </Row>
      <Row type="flex" justify="center" style="margin-top: 8px;">
        <!-- See Pricing -->
        <!-- Start Your Free Trial -->
        <GetStartedButton :arrow="true" :tall="true" title="Get Started for Free!"></GetStartedButton>
      </Row>
    </Col>
  </Row>
</template>
<script>
import GetStartedButton from './GetStartedButton';

export default {
  components: { GetStartedButton },
  props: {
    tone: { type: String, default: 'light' },
  },
};
</script>
<style lang="css" scoped>
.content-section {
  text-align: center;
  padding: 110px 4vw;
  font-weight: 400;
}

.content-section.content-section-light {
  color: rgba(0,0,0,0.7);
  background: none;
}

.content-section.content-section-dark {
  color: #fff;
  background: rgba(44, 56, 73);
}

.content-text-title {
  padding-bottom: 8px;
  font-size: 32px;
  line-height: 40px;

}

.content-text-sub-title {
  font-size: 1rem;
  max-width: 600px;
  text-align: center;
  padding: 16px 46px;
  padding-top: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/AggressiveCTA.vue